import { render } from "./ProgramCollector.vue?vue&type=template&id=80b03c32&scoped=true"
import script from "./ProgramCollector.vue?vue&type=script&lang=js"
export * from "./ProgramCollector.vue?vue&type=script&lang=js"

import "./ProgramCollector.vue?vue&type=style&index=0&id=80b03c32&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80b03c32"]])

export default __exports__